import { ChangeEvent, KeyboardEvent } from "react";
import FormProps from "data/forms";
import RecruitFormFields from "./types";
import TextInput from "Components/molecule/inputs/text-input";
import SelectInput, { SelectOption } from "Components/molecule/inputs/select-input";
import PrimaryButton from "Components/atoms/buttons/primary-button";
import SecondaryButton from "Components/atoms/buttons/secondary-button";
import FormContainer from "Components/atoms/containers/form-container";
import Recruit from "models/recruit";

interface RecruitFormProps extends FormProps<RecruitFormFields> {
    jobTitles: SelectOption[]
    managers: SelectOption[]
    searchQuery: string
    onSearchQueryChange: (_value: string) => void
    onSearch: () => void
    searching: boolean
    searchResults: Recruit[]
    onSelectRecruit: (_recruit: Recruit) => void
    editable: boolean
}

const RecruitForm = ({
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    jobTitles,
    managers,
    searchQuery,
    onSearchQueryChange,
    onSearch,
    searching,
    searchResults,
    onSelectRecruit,
    editable,
}: RecruitFormProps) => {

    const handleSearchKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            onSearch();
        }
    }

    return <div className="d-flex flex-column gap-3 mb-4">
        {/* {editable && <h6>Search for an existing recruit by name or email, or fill out their details below to create a new one.</h6>}
        {editable && <div className="d-flex gap-2 align-items-center">
            <TextInput
                className="flex-grow-1"
                value={searchQuery}
                placeholder="Search by name or email"
                onChange={(e: ChangeEvent<HTMLInputElement>) => onSearchQueryChange(e.target.value)}
                onKeyDown={handleSearchKeyDown}
            />
            <PrimaryButton disabled={searching} onClick={onSearch}>
                {searching ? "Searching..." : "Search"}
            </PrimaryButton>
        </div>}
        {editable && searchResults.length > 0 && (
            <div className="d-flex flex-column gap-1">
                {searchResults.map(r => (
                    <SecondaryButton
                        key={r.id}
                        onClick={() => onSelectRecruit(r)}
                    >
                        {r.commonName ?? r.firstName} {r.lastName} — {r.email}
                    </SecondaryButton>
                ))}
            </div>
        )} */}
        <FormContainer inputs={<>
            <TextInput
                className="col-12 col-md-6 col-lg-4"
                disabled={!editable}
                required
                name="firstName"
                label="First Name"
                placeholder="First Name"
                value={values.firstName}
                error={!!touched.firstName && !!errors.firstName}
                message={touched.firstName ? errors.firstName : undefined}
                onChange={handleChange}
                onBlur={handleBlur}
            />
            <TextInput
                className="col-12 col-md-6 col-lg-4"
                disabled={!editable}
                name="middleName"
                label="Middle Name"
                placeholder="Middle Name"
                value={values.middleName}
                error={!!touched.middleName && !!errors.middleName}
                message={touched.middleName ? errors.middleName : undefined}
                onChange={handleChange}
                onBlur={handleBlur}
            />
            <TextInput
                className="col-12 col-md-6 col-lg-4"
                disabled={!editable}
                required
                name="lastName"
                label="Last Name"
                placeholder="Last Name"
                value={values.lastName}
                error={!!touched.lastName && !!errors.lastName}
                message={touched.lastName ? errors.lastName : undefined}
                onChange={handleChange}
                onBlur={handleBlur}
            />
            <TextInput
                className="col-12 col-md-6 col-lg-4"
                disabled={!editable}
                name="commonName"
                label="Preferred Name"
                placeholder="Preferred Name"
                value={values.commonName}
                error={!!touched.commonName && !!errors.commonName}
                message={touched.commonName ? errors.commonName : undefined}
                onChange={handleChange}
                onBlur={handleBlur}
            />
            <TextInput
                className="col-12 col-md-6 col-lg-4"
                disabled={!editable}
                required
                name="email"
                label="Email"
                placeholder="Email"
                value={values.email}
                error={!!touched.email && !!errors.email}
                message={touched.email ? errors.email : undefined}
                onChange={handleChange}
                onBlur={handleBlur}
            />
            <TextInput
                className="col-12 col-md-6 col-lg-4"
                disabled={!editable}
                name="phone"
                label="Phone"
                placeholder="Phone"
                value={values.phone}
                error={!!touched.phone && !!errors.phone}
                message={touched.phone ? errors.phone : undefined}
                onChange={handleChange}
                onBlur={handleBlur}
            />
            <SelectInput
                className="col-12 col-md-6 col-lg-4"
                disabled={!editable}
                required
                name="jobTitleId"
                label="Position"
                value={values.jobTitleId}
                options={jobTitles}
                error={!!touched.jobTitleId && !!errors.jobTitleId}
                message={touched.jobTitleId ? errors.jobTitleId : undefined}
                onChange={handleChange}
                onBlur={handleBlur}
            />
            <SelectInput
                className="col-12 col-md-6 col-lg-4"
                disabled={!editable}
                required
                name="managerId"
                label="Hiring Manager"
                value={values.managerId}
                options={managers}
                error={!!touched.managerId && !!errors.managerId}
                message={touched.managerId ? errors.managerId : undefined}
                onChange={handleChange}
                onBlur={handleBlur}
            />
            <TextInput
                className="col-12"
                disabled={!editable}
                name="address"
                label="Address"
                placeholder="Address"
                value={values.address}
                error={!!touched.address && !!errors.address}
                message={touched.address ? errors.address : undefined}
                onChange={handleChange}
                onBlur={handleBlur}
            />
        </>} />
    </div>
}

export default RecruitForm
